// extracted by mini-css-extract-plugin
export var clauseRow = "_bs-6";
export var emptyState = "_bs-d";
export var filterContent = "_bs-a";
export var filterGroup = "_bs-1";
export var filterGroupContainer = "_bs-0";
export var nestedGroup = "_bs-2";
export var nestedGroupContent = "_bs-b";
export var nestedGroupDepth1 = "_bs-3";
export var nestedGroupDepth2 = "_bs-4";
export var nestedGroupDepth3 = "_bs-5";
export var nestedGroupEmpty = "_bs-c";
export var operatorAnd = "_bs-8";
export var operatorOr = "_bs-9";
export var operatorToggle = "_bs-7";
export var removeGroupButton = "_bs-e";